import React from "react";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface Props {
  value: string
  onChange: (newValue: string) => void


  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  loading?: boolean
  hasError?: boolean;
  innerRef?: React.Ref<HTMLInputElement>;
}

export const GlobalLocationNumberInput = (props: Props) => {

  const onChange = (newvalue: string) => {
    // Ensure only digits are entered
    const digitsOnly = newvalue.replace(/\D/g, "");
    props.onChange(digitsOnly);
  }

  const onPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const text: string = e.clipboardData.getData("text").trim();
    const digitsOnly = text.replace(/\D/g, "").substring(0, serverReference.constants.company.exactGlobalLocationNumberLength);
    props.onChange(digitsOnly);
  };

  return <InputBase
    ref={props.innerRef}
    maxLength={serverReference.constants.company.exactGlobalLocationNumberLength}
    value={props.value}
    onChange={onChange}
    onPaste={onPaste}
    onBlur={props.onBlur}
    onFocus={props.onFocus}
    onEnter={props.onEnter}
    onEsc={props.onEsc}
    focusOnMount={props.focusOnMount}
    disabled={props.disabled}
    placeholder={props.placeholder}
    loading={props.loading}
    error={props.hasError}
  />
}
